module.exports = __webpack_public_path__ + "static/media/power-hp3.750865c5.png";